import { render, staticRenderFns } from "./Botao.vue?vue&type=template&id=9bdee3d6&scoped=true&lang=pug"
import script from "./Botao.vue?vue&type=script&lang=js"
export * from "./Botao.vue?vue&type=script&lang=js"
import style0 from "./Botao.styl?vue&type=style&index=0&id=9bdee3d6&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bdee3d6",
  null
  
)

export default component.exports